<script>
    import eventProxyMixin from "@core/Components/DragAndDrop/Mixins/eventProxy";
    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions'

    import LoadingBox from "@core/Components/Util/LoadingBox.vue";
    import DragAndDropDraggable from "@core/Components/DragAndDrop/DragAndDropDraggable.vue";
    
    const isBoolean = v => typeof v === 'boolean';
    
    export default {
        name: 'canvas-area-draggable',
        mixins: [eventProxyMixin, permissionsMixin],
        render(createElement, context) {
            const vm = this;
            
            //Triggering a full re-render causes things to break
            //hold off with our actual component rendering until we know which component to render
            if(!vm.canRender){
                return createElement(LoadingBox);
            }
            
            //Drag and Drop should be disabled when a user can't edit the current journey
            if(!vm.canWrite){
                return vm.$slots.default;
            }
            
            //this.$el.parentElement.insertBefore(endpoint.canvas, this.$el.nextElementSibling);
            return createElement(DragAndDropDraggable, {
                class: 'draggable',
                props: vm.$props,
                on: {
                    start() {
                        //Grouping our element together with its endpoints allows us to render an element on top of
                        //another element without the other element's endpoints getting rendered on top of the current
                        //element due to z-index frackery
                        vm.$el.parentElement.append(
                            vm.$el,
                            ...vm.jsPlumbInstance.getEndpoints(vm.$el).map(x => x.canvas)
                        );
                        
                        vm.$emit('start', ...arguments);
                    },
                    stop: this.createEventProxy('stop'),
                    drag: this.createEventProxy('drag')
                }
            }, [vm.$slots.default]);
        },
        computed: {
            canRender(){
                return isBoolean(this.hasWritePermission) && isBoolean(this.hasSpecialWritePermission);
            }
        },
        props: {
            jsPlumbInstance: {
                type: Object,
                required: true
            },
            containment: {
                type: Boolean,
                required: false
            }
        }
    }
</script>

<style scoped>
    * {
        position: absolute;
    }
    
    :not(.draggable) {
        /* Prevent our cursor from tricking the user into thinking the element is draggable */
        cursor: auto !important;
    }
</style>